/**
 * Interfaz abstracta para gestión de cookies
 */
export abstract class CookieRepository {
  /**
   * Establece una cookie con sus opciones
   * @param name Nombre de la cookie
   * @param value Valor de la cookie
   * @param options Opciones (path, domain, expires, secure, sameSite)
   */
  abstract setCookie(
    name: string,
    value: string,
    options?: CookieOptions
  ): void;

  /**
   * Obtiene el valor de una cookie
   * @param name Nombre de la cookie
   * @returns Valor de la cookie o undefined si no existe
   */
  abstract getCookie(name: string): string | undefined;

  /**
   * Elimina una cookie específica
   * @param name Nombre de la cookie
   */
  abstract deleteCookie(name: string): void;

  /**
   * Obtiene todas las cookies como objeto
   * @returns Objeto con todas las cookies
   */
  abstract getAllCookies(): Record<string, string>;

  /**
   * Elimina todas las cookies
   */
  abstract deleteAllCookies(): void;

  /**
   * Verifica si une cookie existe
   * @param name Nombre de la cookie
   * @returns true si existe, false en caso contrario
   */
  abstract exists(name: string): boolean;
}

/**
 * Opciones para las cookies
 */
export type CookieOptions = {
  path?: string;
  domain?: string;
  expires?: Date | number;
  secure?: boolean;
  sameSite?: 'Strict' | 'Lax' | 'None';
  maxAge?: number;
  // Metadatos de auditoría (opcional)
  userId?: string;           // ID del usuario que crea/modifica la cookie
  userName?: string;         // Nombre del usuario
  timestamp?: number;        // Timestamp de creación
  userAgent?: string;        // Dispositivo/navegador
  metadata?: Record<string, any>; // Datos adicionales personalizados
};
